module.exports = __webpack_public_path__ + "img/productLogo.e8182602.jpg";